"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _lodash = require("lodash");

var _connectToMedia = _interopRequireDefault(require("../../../Media/connectToMedia"));

var _AnimatorContainer = _interopRequireDefault(require("./AnimatorContainer"));

var _PropsToStateComponent = _interopRequireDefault(require("../../../../utilities/transcriptLib/PropsToStateComponent"));

var _connectToTranscript = _interopRequireDefault(require("../connectToTranscript"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var mapStateToProps = function mapStateToProps(state) {
  return _extends({}, state.media, {
    skipPrevNextHit: state.media.skipPrevNextHit
  });
};

var AnimatorPlayerFilter = /*#__PURE__*/function (_PropsToStateComponen) {
  _inheritsLoose(AnimatorPlayerFilter, _PropsToStateComponen);

  function AnimatorPlayerFilter() {
    return _PropsToStateComponen.apply(this, arguments) || this;
  }

  var _proto = AnimatorPlayerFilter.prototype;

  _proto.propsToState = function propsToState(pProps) {
    var props = pProps || this.props;
    return (0, _lodash.pick)(_PropsToStateComponen.prototype.propsToState.call(this, props), "identifiedRangeBrackets,identifiedRanges,currentTime,currentPosition,paused,onSeek,skipPrevNextHit,onSkipPrevNextHit".split(","));
  };

  _proto.render = function render() {
    return /*#__PURE__*/_react["default"].createElement(_AnimatorContainer["default"], this.state);
  };

  return AnimatorPlayerFilter;
}(_PropsToStateComponent["default"]);

var _default = (0, _connectToMedia["default"])(mapStateToProps)((0, _connectToTranscript["default"])(AnimatorPlayerFilter));

exports["default"] = _default;